import { FadeRelaxed } from '@fluentui/react-motion-components-preview';
export const DialogBackdropMotion = FadeRelaxed;
